
import React from "react";
import { Button } from "@/components/ui/button";

interface SampleQuestionsProps {
  sampleQuestions: string[];
  handleSampleQuestion: (sample: string) => void;
}

const SampleQuestions: React.FC<SampleQuestionsProps> = ({
  sampleQuestions,
  handleSampleQuestion
}) => {
  return (
    <div className="mb-8">
      <h2 className="text-xl font-semibold text-[#403E43] mb-4">Common Questions</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
        {sampleQuestions.map((sample, index) => (
          <Button 
            key={index} 
            variant="outline" 
            className="h-auto py-3 px-4 justify-start border-heaven-gold/20 text-heaven-gold hover:bg-heaven-gold/5 text-sm text-left whitespace-normal break-words"
            onClick={() => handleSampleQuestion(sample)}
          >
            {sample}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default SampleQuestions;
